<template>
    <div style="float: left">
        <span
            class="edited-by"
            v-show="false"
            @click="getRevisionHistory('survey', id)">
            (Edited by {{ event.modified_name }} )
        </span>
        <el-dialog
            :visible.sync="showHistory"
            :append-to-body="true"
            class="send-now-modal record-history-dialog"
            @close="showHistory = false"
            width="70%">
            <div slot="title">Edit History</div>
            <div class="loading-content" v-if="loadHistory">
                    <LoadSpinnerIcon type="primary"></LoadSpinnerIcon>
                    Loading Revision History
            </div>
            <div v-else-if="filteredHistoryList && Array.isArray(filteredHistoryList) && filteredHistoryList.length > 0">
                <div v-for="(history, index) in filteredHistoryList" :key="index" class="record-history-body">
                    <div v-if="history.id === question.id" class="history-list">
                        <div class="history-header">
                            <ImgPlaceholderIcon></ImgPlaceholderIcon>
                            <span class="name">{{history.modified_name || history.created_name || history.requested_name}}</span>
                            <div class="oval"></div>
                            <span class="date">{{formatDateTime(history.modified_time || history.completed_time) || formatDateTime(history.created)}}</span>
                        </div>
                        <div 
                            class="response-history"
                            :is="responseType(question)"
                            :response="getResponse(question.type, history.answer)"
                            :question="question">
                        </div>
                    </div>
                </div>
            </div>
            <div v-else style="color:red">  
                {{errorState}}
            </div>
            <div class="footer">
                <el-button
                    type="primary"
                    size="small"
                    class="send-button"
                    @click="showHistory = false">
                        Close
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadSpinnerIcon from '@/module/component/icon/LoadSpinner'
import formatDateTime from '@/module/util/format-date-time'
import ImgPlaceholderIcon from '@/module/add/icons/ImgPlaceholder.vue'
import responseMap from './analysis/response/partialResponse/map'
import Responses from './analysis/response/partialResponse/components'

const radioOptions = Array.from(Array(5)).map((_, index) => ({
    label: index + 1,
    value: index + 1
}))

const starOptions = Array.from(Array(5)).map((_, index) => ({
    label: (index + 1) + ' star',
    value:  String(index)
}))

export default {
    name: 'survey-history',

    props: {
        /**
         * The main question content
         */
        question: {
            type: Object
        },
        /**
        * Survey id
        */
        id: {
            type: String
        },
        event: {
            type: Object
        },
        patient: {
            type: Object
        }
    },

    data() {
        return {
            filteredHistoryList: [],
            showHistory: false,
            loadHistory: false,
            errorState: "No revision history found for this question"
        }
    },

    methods: {
        formatDateTime,

        ...mapActions('provider', [
            'revisionHistory',
            'getProviderList',
        ]),
        responseType(question) {
			return responseMap[question.type]
		},
        getRevisionHistory(type, id) {
            this.showHistory = true
            this.loadHistory = true
            this.revisionHistory({
                type,
                id,
                event: this.event.response,
                patient: this.patient.id,
                provider: this.event.provider.split(':')[0],
            }).then((response) => {
                const historyList = response.revision && response.revision.history
                this.loadHistory = false
                this.setFilteredHistoryList(historyList)
            }).catch(error => {
                this.loadHistory = false
                this.errorState = "Sorry there was an error getting revision history"
            })
        },
        setFilteredHistoryList(historyList) {
            this.filteredHistoryList = historyList.filter(elem => elem.id === this.question.id)
        },
        getUploader(uploaderId) {
            if(this.getUser && this.getUserId === uploaderId)
                return this.getUser.name
            if(this.getProviderList) {
                const provider = this.getProviderList.find(({ provider }) => provider === uploaderId)
                if(provider)
                    return provider.name
            }
            return null
        },
        getResponse(type, answer) {
            if(type === 'long_text_bubble' && answer && answer.answer)
                return answer.answer
            return answer
        }
    },

    computed: {
        ...mapGetters('auth', ['getUserId']),
        ...mapGetters('user', [
            'getUser'
        ]),
    },

    components: {
        ...Responses,
        LoadSpinnerIcon,
        ImgPlaceholderIcon,
    }

}
</script>

<style lang="scss" scoped>

.edited-by {
    color: #999;
    font-size: 12px;
    margin-right: 8px;
    cursor: pointer;
    white-space: nowrap;
}
.loading-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    svg {
        height: 30px;
        width: 30px;
        margin-bottom: 10px;
    }
}
.record-history-body:not(:last-child) {
    .history-list {
         border-bottom: 1px solid #e2e2e2;
    }
}
.record-history-body {
    margin-top: 20px;
}
.history-header {
    display: flex;
    align-items: center;
    .oval {
        height: 3px;
        width: 3px;
        margin-bottom: 2px;
        background-color: #666666;
        border-radius: 50%;
        margin-left: 8px;
        margin-right: 8px;
    }
    .name {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-left: 11px;  
    }
    .date {
        font-size: 14px;
        color: #666666;
    }
}
.history-comment {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    padding: 15px 0;
    word-break: break-word;
}
.response-history {
    padding: 16px 60px 16px 35px;
}
.send-now-modal.record-history-dialog{
    .footer {
        display: block;
        height: 20px;
        margin-top: 20px;
        text-align: right;
    }
    .el-select {
        width: 50%;
    }
}
</style>
